<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.pa-4
        div
          div.s1.primary--text {{ $t('order_details') }}
          div.c1.basic600--text {{ $t('order_details_text') }}
      v-card-text.pa-0
        v-row.px-4(no-gutters align="center")
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.customerName" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customer_name') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.amountPaid" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('amount_paid') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.shippingMethod" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('fulfilment_method') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.paymentMethod" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('payment_method') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.address" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('address') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.customerPhone" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('phone_number') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.customerEmail" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('email_address') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.orderMessage" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customers_note') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.itemsOrdered" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('items_ordered') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.extraInfo" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('extra_info') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.source" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('source') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="orderDetails.scheduledDateTime" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('scheduled_date_time') }}
          v-col.py-2(v-if="Auth('root', 'lead_remarks')" cols="6")
            y-checkbox(v-model="orderDetails.remarks" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('remarks') }}
        .preview
          div.px-4.label.basic600--text.text-uppercase {{ $t('preview') }}
          v-card.mx-2.mb-2.mt-4.py-2
            div.px-4
              div.d-flex.align-center(v-if="orderDetails.customerName || orderDetails.source")
                template(v-if="orderDetails.customerName")
                  div.s2.info500--text.mb-1 Jane Doe
                  v-spacer
                div.c1.basic600--text.mb-1(v-if="orderDetails.source") Yezza Store

              div.p2.basic700--text.mb-1(v-if="orderDetails.customerPhone") +6 012345 6789

              div.p2.basic700--text.mb-1(v-if="orderDetails.customerEmail") customer@gmail.com

              .customer-selection(v-if="orderDetails.shippingMethod || orderDetails.scheduledDateTime || orderDetails.address")
                div.c1.basic600--text.mb-1 {{ $t('customer_selection') }}:
                div.d-flex.align-center.mb-1(v-if="orderDetails.shippingMethod")
                  eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  div.p2.basic700--text Lalamove

                div.d-flex.align-center.mb-1(v-if="orderDetails.scheduledDateTime")
                  eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  div.p2.basic700--text Fri, 01/01/21 at 12:00PM

                v-row.mb-1(no-gutters v-if="orderDetails.address")
                  v-col.shrink.pr-1
                    eva-icon.mb-n1(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  v-col.pr-6(cols="10")
                    div.p2.basic700--text 60000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
                
                div.d-flex.align-center.mb-1(v-if="orderDetails.paymentMethod")
                  eva-icon.mb-n1.mr-1(name="credit-card-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  div.p2.basic700--text Mastercard

              div.d-flex.mt-4.mb-2(v-if="orderDetails.amountPaid")
                div.c1.basic700--text 2 items
                div.c1.basic700--text.ml-4 RM 100.00 paid
              
              template(v-if="orderDetails.itemsOrdered")
                v-divider.basic300.mb-2
                div.d-flex.mb-1
                  div.c1.primary500--text 1x
                  div.ml-3
                    div.c2.primary500--text Product A
                div.d-flex.mb-2
                  div.c1.primary500--text 1x
                  div.ml-3
                    div.c2.primary500--text Product B
                    
              template(v-if="orderDetails.orderMessage")
                v-divider.basic300.mb-2
                div.c1.basic600--text.mb-2 Message: No cutleries

              template(v-if="orderDetails.remarks")
                v-divider.basic300.mb-2
                div.c1.basic600--text.mb-2 Remark: This is remark from merchant regarding this order.

              template(v-if="orderDetails.extraInfo")
                v-divider.basic300.mb-2
                div.c1.primary--text.mb-1 Extra info 1: Text
                div.c1.primary--text.mb-1 Extra info 2: Text

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='resetDefault')
          .button-Aa-small.primary400--text {{ $t('reset_to_default') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="saveOrderDetails" dark)
          .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderDetailsFilter',
  props: ['open', 'field'],
  data: () => ({
    orderDetails: {}
  }),
  computed: {
    ...mapGetters({
      details: 'orders/getOrderDetails'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    this.orderDetails = { ...this.details }
  },
  methods: {
    saveOrderDetails () {
      this.$store.commit('orders/setOrderDetails', this.orderDetails)
      this.showModal = false
    },
    resetDefault () {
      this.orderDetails = {
        customerName: true,
        shippingMethod: true,
        paymentMethod: false,
        customerPhone: false,
        customerEmail: false,
        itemsOrdered: true,
        source: false,
        amountPaid: true,
        address: false,
        orderMessage: false,
        extraInfo: false,
        scheduledDateTime: true,
        remarks: false,
      }
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "order_details": "Order details",
    "order_details_text": "Control what you see when viewing your order list"
  },
  "id": {
    "order_details": "Detail Order",
    "order_details_text": "Kontrol apa yang kamu lihat saat melihat daftar pesanan kamu"
  }
}
</i18n>
